export interface ServiceSetupPresentation {
  missing: boolean;
  description: string;
  actionLabel: string;
}

export function getServiceSetupPresentation(count: number): ServiceSetupPresentation {
  if (count === 0) {
    return {
      missing: true,
      description: 'No services are defined yet. Define them before Service mapping and publication.',
      actionLabel: 'Define services',
    };
  }
  return {
    missing: false,
    description: `${count} active ${count === 1 ? 'service' : 'services'} defined.`,
    actionLabel: 'Manage services',
  };
}
